module.exports = __webpack_public_path__ + "img/storm-gray.ecfd0cf4.svg";